import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { publish, refCount } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
import { SnackBarResponse } from '../snack-bar-response/snack-bar-response.component';

@Injectable()
export class NotificationService {
  private _notification: BehaviorSubject<string> = new BehaviorSubject(null);
  readonly notification$: Observable<string> = 
  this._notification.asObservable().pipe(publish(), refCount());

  constructor(public snackBar: MatSnackBar) {}

  notify(message) {
    this.snackBar.openFromComponent(SnackBarResponse, {
      duration: 3000,
      data: message,
    });
  }
  notifyFailure(message) {
    this.snackBar.openFromComponent(SnackBarResponse, {
      duration: 3000,
      data: message,
    });
  }
}